export const integrationPermissionsListCanvas = {
  manage_account_settings: {
    title: 'Account-level settings - manage',
    reason: {
      archivev2:
        '<p>This permission is required in order to see Terms. Terms are used to Import courses.</p><p>If your integration will be set to a specific subaccount, please ensure this permission is enabled, in order to pull all courses associated with that subaccount and Term.</p><p>If your integration will be set to the root account and this permission is not set for all subaccounts, only courses in subaccounts with this permission will import successfully. Courses in subaccounts without this permission will fail to import successfully.</p>',
      'ai-detection':
        '<p>This permission is required in order to see Terms. Terms are used to Import courses.</p><p>If your integration will be set to a specific subaccount, please ensure this permission is enabled, in order to pull all courses associated with that subaccount and Term.</p><p>If your integration will be set to the root account and this permission is not set for all subaccounts, only courses in subaccounts with this permission will import successfully. Courses in subaccounts without this permission will fail to import successfully.</p>',
      datax:
        '<p>This permission is required in order to see Terms. Terms are used to Import courses.</p><p>If your integration will be set to a specific subaccount, please ensure this permission is enabled, in order to pull all courses associated with that subaccount and Term.</p><p>If your integration will be set to the root account and this permission is not set for all subaccounts, only courses in subaccounts with this permission will import successfully. Courses in subaccounts without this permission will fail to import successfully.</p>',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax'],
    },
    optional: {
      root: ['archivev2', 'ai-detection', 'datax'],
      account: [],
    },
    root_context: 'archive_terms',
    account_context: '',
  },
  view_analytics: {
    title: 'Analytics - view pages',
    reason: {
      archivev2: 'Needed for Archiving',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_announcements: {
    title: 'Announcements - view',
    reason: {
      archivev2: 'Needed for Archiving Announcements',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_assignments_add: {
    title: 'Assignments and Quizzes - add',
    reason: {
      archivev2: 'Needed for syncing Courses',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  manage_assignments_edit: {
    title: 'Assignments and Quizzes - edit',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      'ai-detection': 'Needed for accessing assigments to detect AI content',
      datax: 'Needed for collecting assignment data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_course_content_add: {
    title: 'Course Content - add',
    reason: {
      archivev2: 'Needed for syncing Courses',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  manage_course_content_edit: {
    title: 'Course Content - edit',
    reason: {
      archivev2: 'Needed for syncing Courses',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_course_content: {
    title: 'Course Content - view',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_files_add: {
    title: 'Course Files - add',
    reason: {
      archivev2: 'Needed for syncing Courses',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  manage_files_edit: {
    title: 'Course Files - edit',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      'ai-detection':
        'Needed for accessing submitted files to detect AI content',
      datax: 'Needed for collecting course submission data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_sections_edit: {
    title: 'Course Sections - edit',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      datax: 'Needed for collecting course section data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_courses_add: {
    title: 'Courses - add',
    reason: {
      archivev2: 'Needed for syncing Courses',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  manage_courses_admin: {
    title: 'Courses - manage / update',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      archive: 'Needed for syncing',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_courses_publish: {
    title: 'Courses - publish',
    reason: {
      archivev2:
        'Needed for archiving and syncing Courses in a published state',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_published',
  },
  undelete_courses: {
    title: 'Courses - undelete',
    reason: {
      archivev2: 'Needed for restoring archived Courses',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: ['archivev2'],
      account: ['archivev2'],
    },
    root_context: 'restore_courses',
    account_context: 'restore_courses',
  },
  view_course_changes: {
    title: 'Courses - view change logs',
    reason: {
      archivev2: 'This permission is only available at the root level.',
      'ai-detection': 'This permission is only available at the root level.',
      datax: 'This permission is only available at the root level.',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: [],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_course_list: {
    title: 'Courses - view list',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      'ai-detection': 'Needed for accessing courses to detect AI content',
      datax: 'Needed for collecting course data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  create_forum: {
    title: 'Discussions - create',
    reason: {
      archivev2: 'Needed for syncing Courses',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  moderate_forum: {
    title: 'Discussions - moderate',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      'ai-detection': 'Needed for accessing discussions to detect AI content',
      datax: 'Needed for collecting discussion data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_forum: {
    title: 'Discussions - view',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      'ai-detection': 'Needed for accessing discussions to detect AI content',
      datax: 'Needed for collecting discussion data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_grades: {
    title: 'Grades - edit',
    reason: {
      archivev2: 'Needed for archiving Courses',
      'ai-detection': 'Needed for accessing submissions to detect AI content',
      datax: 'Needed for collecting submission data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  view_all_grades: {
    title: 'Grades - view all grades',
    reason: {
      archivev2: 'Needed for archiving Courses',
      'ai-detection': 'Needed for accessing submissions to detect AI content',
      datax: 'Needed for collecting grade data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  view_audit_trail: {
    title: 'Grades - view audit trail',
    reason: {
      archivev2: 'Needed for archiving Courses',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  view_grade_changes: {
    title: 'Grades - view change logs',
    reason: {
      archivev2: 'Needed for archiving Courses',
      'ai-detection': 'Needed for accessing submissions to detect AI content',
      datax: 'Needed for collecting grade data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_groups_add: {
    title: 'Groups - add',
    reason: {
      archivev2: 'Needed for archiving and restoing archived Courses',
      'ai-detection': 'Needed for accessing groups to detect AI content',
    },
    required: {
      root: [],
      account: ['ai-detection'],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  manage_groups_manage: {
    title: 'Groups - manage',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      datax: 'Needed for collecting group data',
      archive: 'Needed for syncing',
      'ai-detection': 'Needed for accessing groups to detect AI content',
    },
    required: {
      root: [],
      account: ['archivev2', 'datax', 'archive', 'ai-detection'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  view_group_pages: {
    title: 'Groups - view all student groups',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      'ai-detection': 'Needed for accessing groups to detect AI content',
      datax: 'Needed for collecting group data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_account_banks: {
    title: 'Item Banks - manage account',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_outcomes: {
    title: 'Learning Outcomes - add / edit / delete',
    reason: {
      archivev2: 'Needed for syncing Courses',
      datax: 'Needed for collecting outcome data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_lti_add: {
    title: 'LTI - add',
    reason: {
      archivev2: 'Needed for syncing Courses',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  manage_lti_edit: {
    title: 'LTI - edit',
    reason: {
      'ai-detection': 'This permission is used for SCORM',
      datax: 'This permission is used for SCORM',
      archivev2: 'Needed for syncing Courses',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_sis: {
    title: 'SIS Data - manage',
    reason: {
      archivev2:
        'Needed for collecting sis id of courses and students, only available at root level',
      'ai-detection':
        'Needed for accessing sis id of courses and students, only available at root level',
      datax: 'Needed for collecting SIS data, only available at root level',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: ['datax', 'archivev2', 'ai-detection'],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_reports: {
    title: 'Manage account or course-level reports',
    reason: {
      archivev2: 'Needed for archiving Courses',
    },
    required: {
      root: ['archivev2'],
      account: ['archivev2'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_proficiency_scales: {
    title: 'Outcome Mastery Scales - add / edit',
    reason: {
      archivev2: 'Needed for syncing Courses',
      datax: 'Needed for collecting outcome data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_proficiency_calculations: {
    title: 'Outcome Proficiency Calculations - add / edit',
    reason: {
      archivev2: 'Needed for syncing Courses',
      datax: 'Needed for collecting outcome data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_wiki_create: {
    title: 'Pages - create',
    reason: {
      archivev2: '',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: [],
      account: ['archivev2'],
    },
    root_context: '',
    account_context: 'sync_course',
  },
  manage_wiki_update: {
    title: 'Pages - update',
    reason: {
      archivev2: 'Needed for syncing Courses',
    },
    required: {
      root: [],
      account: ['archivev2'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_question_banks: {
    title: 'Question banks - view and link',
    reason: {
      archivev2: 'Needed for archiving and syncing Courses',
      datax: 'Needed for collecting question bank data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  view_quiz_answer_audits: {
    title: 'Quizzes - view submission log',
    reason: {
      archivev2: 'Needed for archiving Courses',
      'ai-detection': 'Needed for accessing submissions to detect AI content',
      datax: 'Needed for collecting submission data',
      archive: 'Needed for syncing',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_rubrics: {
    title: 'Rubrics - add / edit / delete',
    reason: {
      archivev2: 'Needed for syncing Courses',
      datax: 'Needed for collecting rubric data',
      archive: 'Needed for syncing',
    },
    required: {
      root: [],
      account: ['archivev2', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  view_statistics: {
    title: 'Statistics - view',
    reason: {
      archivev2: 'Needed for archiving Courses',
      archive: 'Needed for syncing',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax', 'archive'],
      account: ['archivev2', 'ai-detection', 'datax', 'archive'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_user_logins: {
    title: 'Users - manage login details',
    reason: {
      'ai-detection':
        'This permission is only available at the Root Level and is needed to access user files in courses.',
      datax:
        'This permission is only available at the Root Level and is needed to access user files in courses.',
      archivev2:
        'This permission is only available at the Root Level and is needed to access user files in courses.',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax'],
      account: [],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_roster: {
    title: 'Users - view list',
    reason: {
      archivev2: 'Needed for archiving users in Courses',
      'ai-detection': 'Needed for accessing users to detect AI content',
      datax: 'Needed for collecting user data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax'],
      account: ['archivev2', 'ai-detection', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  view_user_logins: {
    title: 'Users - view login IDs',
    reason: {
      archivev2: 'Needed for archiving users in Courses',
      'ai-detection': 'Needed for accessing users to detect AI content',
      datax: 'Needed for collecting user data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax'],
      account: ['archivev2', 'ai-detection', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  read_email_addresses: {
    title: 'Users - view primary email address',
    reason: {
      archivev2: 'Needed for archiving users in Courses',
      'ai-detection': 'Needed for accessing users to detect AI content',
      datax: 'Needed for collecting user data',
    },
    required: {
      root: ['archivev2', 'ai-detection', 'datax'],
      account: ['archivev2', 'ai-detection', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_developer_keys: {
    title: 'Developers Key',
    reason: {
      datax:
        'Optional Permission: This permission is needed if K16 will be setting up Data Services. If Data Services is already enabled or the institution will be setting up Data Services on their own this permission is not required.',
      'ai-detection':
        'Optional Permission: This permission is needed if K16 will be setting up Data Services. If Data Services is already enabled or the institution will be setting up Data Services on their own this permission is not required.',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: ['ai-detection', 'datax'],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  manage_data_services: {
    title: 'Data Services - Manage',
    reason: {
      datax:
        'This permission allows us to capture Canvas Live Events. You will need to enable Data Services if it is not already set up in your Canvas Instance. If K16 will be provided with a Canvas User Account, we can complete the set up for you.',
      'ai-detection':
        'This permission allows us to capture Canvas Live Events. You will need to enable Data Services if it is not already set up in your Canvas Instance. If K16 will be provided with a Canvas User Account, we can complete the set up for you.',
    },
    required: {
      root: [],
      account: [],
    },
    optional: {
      root: ['ai-detection', 'datax'],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
};

export const integrationPermissionsListBrightspace = {
  userAccess: {
    title: 'User Access',
    reason: {
      archive: 'Access to user information is required for collecting data.',
      archivev2: 'Access to user information is required for collecting data.',
      datax: 'Access to user information is required for collecting data.',
    },
    required: {
      root: ['archive', 'archivev2', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  userDetails: {
    title: 'User Details',
    reason: {
      archive: 'Access to user information is required for collecting data.',
      archivev2: 'Access to user information is required for collecting data.',
      datax: 'Access to user information is required for collecting data.',
    },
    required: {
      root: ['archive', 'archivev2', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  roles: {
    title: 'Roles',
    reason: {
      archive: 'Access to user information is required for collecting data.',
      archivev2: 'Access to user information is required for collecting data.',
      datax: 'Access to user information is required for collecting data.',
    },
    required: {
      root: ['archive', 'archivev2', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  ouTypes: {
    title: 'Organizational Unit Types',
    reason: {
      archive: 'Access to user information is required for collecting data.',
      archivev2: 'Access to user information is required for collecting data.',
      datax: 'Access to user information is required for collecting data.',
    },
    required: {
      root: ['archive', 'archivev2', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  courseOfferings: {
    title: 'Course Offerings',
    reason: {
      archive: 'Access to user information is required for collecting data.',
      archivev2: 'Access to user information is required for collecting data.',
      datax: 'Access to user information is required for collecting data.',
    },
    required: {
      root: ['archive', 'archivev2', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
  courseToc: {
    title: 'Course Table of Contents',
    reason: {
      archive: 'Access to user information is required for collecting data.',
      archivev2: 'Access to user information is required for collecting data.',
      datax: 'Access to user information is required for collecting data.',
    },
    required: {
      root: ['archive', 'archivev2', 'datax'],
    },
    optional: {
      root: [],
      account: [],
    },
    root_context: '',
    account_context: '',
  },
};
